/**
 * /admin/translations — the IAA-generator translation registry.
 *
 * Moved 2026-06-21 (nav reorg) off the Compliance "Translations" tab onto a
 * standalone Admin page (reached from the Admin → Translations card). Admin-only
 * for now (Pedro); the future Permissions affordance will let Compliance be
 * granted it. The actual registry UI lives in TranslationTermsSection (unchanged).
 */
import { Container, Group, Stack, Text, Title } from '@mantine/core';
import { IconLanguage } from '@tabler/icons-react';

import { TranslationTermsSection } from '../components/TranslationTermsSection';
import { BackToCompliance } from '../components/BackToCompliance';
import { AccessDeniedAlert } from '../components/RequireAccess';
import { useCurrentUser } from '../hooks/useAuth';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export function TranslationsPage() {
  useDocumentTitle('Translations');
  const { user } = useCurrentUser();

  if (!user) return null;
  if (user.role !== 'admin') return <AccessDeniedAlert />;

  return (
    <Container size="xl">
      <Stack>
        <BackToCompliance to="/admin" label="Back to Admin" />
        <Group gap="xs"><IconLanguage size={22} /><Title order={2}>Translations</Title></Group>
        <Text size="sm" c="dimmed">
          IAA-generator translation registry — the term each stored value prints in
          generated client documents.
        </Text>
        <TranslationTermsSection />
      </Stack>
    </Container>
  );
}
